import { EditorState, Plugin, PluginKey } from 'prosemirror-state';
import { DecorationSet } from 'prosemirror-view';
import { pluginState } from './pluginState';
import { pluginView } from './pluginView';
import { CustomPluginState, PluginConfig } from './types';

export const pluginKey = new PluginKey<CustomPluginState>(
  'collaboration-cursor-plugin',
);

/**
 * Creates a new ProseMirror plugin that enables collaboration cursors using Firebase.
 * @param config - The plugin configuration.
 * @returns A new ProseMirror plugin instance.
 */
export function collaborationCursorPlugin(config: PluginConfig) {
  return new Plugin({
    key: pluginKey,
    state: pluginState(config),
    props: {
      decorations(this: Plugin, state: EditorState) {
        const pluginState = pluginKey.getState(state);
        return pluginState?.decorationSet || DecorationSet.empty;
      },
    },
    view: pluginView,
  });
}
